import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tab__title" }

import { Icon } from "@iconify/vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'DetailsTabTitle',
  props: {
    title: {},
    active: { type: Boolean, default: true },
    isVertical: { type: Boolean },
    size: { default: "md" },
    color: { default: "neutral" },
    iconName: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass([
      'button',
      { active: __props.active, vertical: __props.isVertical },
      `button--${__props.size}`,
      `button--${__props.color}`,
    ]),
    type: "button"
  }, [
    (__props.iconName)
      ? (_openBlock(), _createBlock(_unref(Icon), {
          key: 0,
          icon: __props.iconName
        }, null, 8, ["icon"]))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_1, _toDisplayString(__props.title), 1)
  ], 2))
}
}

})